import { MlFormField } from '@curran-catalog/curran-atomic-library'
import {
  CloudinaryAsset,
  ContentfulObjAddon,
  ContentfulObjFurnitureFabricGrade,
  ContentfulObjFurnitureMainCushion,
  SiteDomain,
} from 'types'
import Image from 'next/image'
import { useFurnitureProduct } from '@hooks/use-furniture-product'
import { FurnitureProductActionTypes } from '@context/furniture-product'
import { MutableRefObject, useEffect } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { environment } from '@config/environment'
import { useAuth } from '@hooks/use-auth'
import { useFlooringWeave } from '@hooks/use-flooring-weave'
import { FlooringWeaveActionTypes } from '@context/flooring-product'
interface ProductProp {
  name?: string
  image?: CloudinaryAsset
  addons?: ContentfulObjAddon[]
  mainCushion?: ContentfulObjFurnitureMainCushion[]
  fabric?: ContentfulObjFurnitureFabricGrade[]
  fabricTitle?: string
  mainCushionsTitle?: string
  addonsTitle?: string
}

interface TmCustomerServiceProp {
  product: ProductProp
  recaptchaRef: MutableRefObject<ReCAPTCHA | null>
}

const TmCustomerService = ({ product, recaptchaRef }: TmCustomerServiceProp) => {
  const isFurniture = environment.siteDomain === SiteDomain.FURNITURE
  const { state, dispatch } = useFurnitureProduct()
  const { dispatch: dispatchFlooring, state: stateFlooring } = useFlooringWeave()
  const { quoteDetails } = state
  const { user } = useAuth({})
  const RECAPTCHA_SITE_KEY = environment.recaptcha.siteKey
  const allTradeCategory = [
    {
      label: 'Residential Interior Designer',
      value: 'INTDESIGNR',
    },
    {
      label: 'Commercial Interior Designer',
      value: 'INTDESIGN',
    },
    {
      label: 'Hospitality',
      value: 'HOSPITINST',
    },
    {
      label: 'Architect',
      value: 'ARCHITECT',
    },
    {
      label: 'Store Design',
      value: 'STOREDES',
    },
    {
      label: 'Purchasing/Procurement',
      value: 'PURCHAGENT',
    },
    {
      label: 'Flooring Dealer/Installer',
      value: 'INSTALL',
    },
    {
      label: 'Commercial Installer',
      value: 'COMINSTALL',
    },
    {
      label: 'Residential Installer',
      value: 'RESIDINSTA',
    },
    {
      label: 'Distributor/Wholesaler',
      value: 'DEALDIST',
    },
    {
      label: 'Consumer',
      value: 'CONSUMER',
    },
    {
      label: 'Other',
      value: 'OTHER',
    },
  ]
  const defaultTC = {
    label:
      user && user.trade_category
        ? allTradeCategory.find((index) => index.value == user.trade_category)?.label ?? 'Consumer'
        : 'Consumer',
    value: user && user.trade_category ? user.trade_category : 'CONSUMER',
  }
  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
    if (isFurniture) dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { error: '' } })
    else dispatchFlooring({ type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE, quoteState: { error: '' } })
    if (fieldName == 'firstName') {
      if (isFurniture)
        dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { firstName: e.target.value } })
      else
        dispatchFlooring({
          type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE,
          quoteState: { firstName: e.target.value },
        })
    }
    if (fieldName == 'lastName') {
      if (isFurniture)
        dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { lastName: e.target.value } })
      else
        dispatchFlooring({ type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE, quoteState: { lastName: e.target.value } })
    }
    if (fieldName == 'email') {
      if (isFurniture)
        dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { email: e.target.value } })
      else dispatchFlooring({ type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE, quoteState: { email: e.target.value } })
    }
    if (fieldName == 'comment') {
      if (isFurniture)
        dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { comment: e.target.value } })
      else
        dispatchFlooring({ type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE, quoteState: { comment: e.target.value } })
    }
    if (fieldName == 'phone') {
      if (isFurniture)
        dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { phone: e.target.value } })
      else dispatchFlooring({ type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE, quoteState: { phone: e.target.value } })
    }
  }
  useEffect(() => {
    if (!quoteDetails?.tradeCategory) {
      if (isFurniture)
        dispatch({
          type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE,
          quoteState: {
            tradeCategory: defaultTC,
          },
        })
      else
        dispatchFlooring({
          type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE,
          quoteState: {
            tradeCategory: defaultTC,
          },
        })
    }
    if (user && isFurniture) {
      if (!quoteDetails?.lastName && !quoteDetails?.email && !quoteDetails?.firstName && !quoteDetails?.phone) {
        dispatch({
          type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE,
          quoteState: {
            phone: user.phone,
            lastName: user.last_name,
            firstName: user.first_name,
            email: user.email,
          },
        })
      }
    } else if (user && !isFurniture) {
      if (
        !stateFlooring.quoteDetails?.lastName &&
        !stateFlooring.quoteDetails?.email &&
        !stateFlooring.quoteDetails?.firstName &&
        !stateFlooring.quoteDetails?.phone
      ) {
        dispatchFlooring({
          type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE,
          quoteState: {
            phone: user.phone,
            lastName: user.last_name,
            firstName: user.first_name,
            email: user.email,
          },
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <div className="flex flex-col p-3">
        {product.image && product.name ? (
          <div className="flex flex-row gap-1 items-center">
            <Image
              src={product.image?.secure_url}
              alt="Request Information"
              width="200"
              height="200"
              className="rounded-lg object-cover object-center"
            />

            <h3 className=" text-lg pb-10 font-medium text-dark text-center">{product.name}</h3>
          </div>
        ) : (
          <div className="relative w-full aspect-[2/1]">
            {product.image && (
              <Image
                src={product.image?.secure_url}
                alt="Request Information"
                fill
                className="rounded-lg object-cover object-center"
              />
            )}
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex flex-col gap-y-4">
          <div className="flex flex-row gap-3">
            <div className="w-1/2">
              <MlFormField
                type="text"
                label="First Name"
                name="first_name"
                onChange={(e) => handleChangeInput(e, 'firstName')}
                required
                autoComplete="given-name"
                value={isFurniture ? quoteDetails?.firstName : stateFlooring.quoteDetails?.firstName || ''}
                error={
                  isFurniture ? quoteDetails?.error == 'firstName' : stateFlooring.quoteDetails?.error == 'firstName'
                }
                errorMessage="This field is required."
              />
            </div>
            <div className="w-1/2">
              <MlFormField
                type="text"
                label="Last Name"
                name="last_name"
                onChange={(e) => handleChangeInput(e, 'lastName')}
                required
                autoComplete="family-name"
                value={isFurniture ? quoteDetails?.lastName : stateFlooring.quoteDetails?.lastName || ''}
                error={
                  isFurniture ? quoteDetails?.error == 'lastName' : stateFlooring.quoteDetails?.error == 'lastName'
                }
                errorMessage="This field is required."
              />
            </div>
          </div>

          <MlFormField
            type="email"
            label="Email"
            name="email"
            onChange={(e) => handleChangeInput(e, 'email')}
            required
            autoComplete="email"
            value={isFurniture ? quoteDetails?.email : stateFlooring.quoteDetails?.email || ''}
            error={isFurniture ? quoteDetails?.error == 'email' : stateFlooring.quoteDetails?.error == 'email'}
            errorMessage="This field is required."
          />
          <MlFormField
            type="tel"
            label="Phone Number"
            name="phone"
            minLength={5}
            onChange={(e) => handleChangeInput(e, 'phone')}
            autoComplete="tel"
            value={isFurniture ? quoteDetails?.phone : stateFlooring.quoteDetails?.phone || ''}
          />

          <MlFormField
            label="Trade Profession"
            type="select"
            options={allTradeCategory}
            name="tradeCategory"
            autoFocus
            filterHandler={(selectedOption) => {
              if (isFurniture)
                dispatch({
                  type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE,
                  quoteState: { tradeCategory: { label: selectedOption.label, value: selectedOption.value } },
                })
              else
                dispatchFlooring({
                  type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE,
                  quoteState: { tradeCategory: { label: selectedOption.label, value: selectedOption.value } },
                })
            }}
            currentOption={
              isFurniture ? quoteDetails?.tradeCategory : stateFlooring.quoteDetails?.tradeCategory ?? defaultTC
            }
          />

          <MlFormField
            label="Comment"
            name="comment"
            onChange={(e) => handleChangeInput(e, 'comment')}
            placeholder={
              isFurniture ? '' : 'Please include details such as preferred color, dimensions, timeline, and budget.'
            }
            autoComplete="comment"
            value={isFurniture ? quoteDetails?.comment : stateFlooring.quoteDetails?.comment || ''}
            rows={2}
            type="textarea"
          />

          <div className="flex justify-center">
            {!!RECAPTCHA_SITE_KEY && (
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={() => {
                  if (isFurniture)
                    dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { error: '' } })
                  else dispatchFlooring({ type: FlooringWeaveActionTypes.SET_PRODUCT_QUOTE, quoteState: { error: '' } })
                }}
              />
            )}
          </div>

          <div className="flex justify-center">
            <p
              className={`${
                quoteDetails?.error == 'recaptcha' || stateFlooring.quoteDetails?.error == 'recaptcha' ? '' : 'hidden'
              } text-red-600 block`}
            >
              {' '}
              Please Complete the ReCAPTCHA
            </p>
          </div>
          <div className="text-center p">
            A representative from our Customer Service team will respond to your request within 1-2 business days.
          </div>
        </div>
      </div>
    </div>
  )
}

export default TmCustomerService
